/**
 * Created by jonahkim on 4/13/16.
 */
(function () {
    "use strict";

    // @ngInject
    function WSAPIRoutesServiceCtor($q,
                                    WSAPIService, Gon){
        this.$q = $q;
        this.WSAPIService = WSAPIService;
        this.gon = Gon;

        this._routes;
    }

    Services.WSAPIRoutesService = Class(function() {
        return {

            constructor: WSAPIRoutesServiceCtor,

            _sanitizeRoutes: function _sanitizeRoutes(routesData){
                var cleanedRoutes = {};
                for (var key in routesData) {
                    var cleanedKey = key.replace(/-/g, '_');
                    cleanedRoutes[cleanedKey] = routesData[key];
                }
                return cleanedRoutes;
            },

            getRoutes: function getRoutes() {

                var defer = this.$q.defer();

                if (!this._routes) {
                    this.WSAPIService.fetch(this.gon.ws_api_url).then(

                        function success(data) {
                            this._routes = this._sanitizeRoutes(data.data);
                            defer.resolve(this._routes);
                        }.bind(this),

                        defer.reject
                    );
                } else {
                    defer.resolve(this._routes);
                }

                return defer.promise;
            },
        };
    });

}());